import type { NextPage } from 'next'
import { useEffect, useState } from "react";
import Head from 'next/head'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Trainer from '../components/trainer/Trainer'
import PaymentOptions from '../components/payment-plans/PaymentPlans'
import { server } from '../config/index'
import UserDashboard from '../components/user-dashboard/Dashboard'
import useIsAuthorized from '@/hooks/useIsAuthorized';
import useUser from '@/hooks/useUser';
import ConversionBlock from '@/components/ConversionBlock';

const Benefits = () => (
  <div className="mt-16 bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 text-white rounded-lg shadow-lg p-8 mb-10">
  <h2 className="text-3xl font-bold mb-6 text-center">Benefits of Our Practice Approach</h2>
  <ul className="list-disc pl-8 text-left mx-auto max-w-3xl space-y-4">
      <li className="flex">
          <div className="mr-2">
              <span className="font-bold">1.</span>
          </div>
          <div>
              <strong>Personalized learning:</strong> Our AI-powered tool provides customized suggestions for improvement,
              allowing you to focus on areas that need the most attention.
          </div>
      </li>
      <li className="flex">
          <div className="mr-2">
              <span className="font-bold">2.</span>
          </div>
          <div>
              <strong>Instant feedback:</strong> Get immediate feedback on your writing, enabling you to learn from your
              mistakes and make adjustments in real-time.
          </div>
      </li>
      <li className="flex">
          <div className="mr-2">
              <span className="font-bold">3.</span>
          </div>
          <div>
              <strong>Varied practice:</strong> With 30 Writing Task 2 topics, you can practice a wide range of scenarios and
              build your confidence.
          </div>
      </li>
      <li className="flex">
          <div className="mr-2">
              <span className="font-bold">4.</span>
          </div>
          <div>
              <strong>Effective learning:</strong> Our recommended learning approach focuses on taking numerous mock exams,
              followed by detailed analysis and specific suggestions for improvement. This method allows you to target your
              weaknesses and continually improve your skills.
          </div>
      </li>
  </ul>
</div>
)


const Home: NextPage = (props) => {

  const { isAuthorized } = useIsAuthorized();

  const user = useUser(isAuthorized);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center">

      <Head>
        <title>IELTS Essay Checker (AI) for Writing Task 2. Practice Writing with Top Accuracy and High Quality Platform that Uses Recent 2023 Official Band Descriptors.</title>
        <meta name="description" content="Increase your IELTS Writing Band with Online Writing Task 2 AI Checker. Instant feedback, Tailored Improvement Suggestions. Practice with our cutting-edge evaluation platform to achieve your target, be it Band 9, 8 or 7." />
        <link rel="canonical" href="https://upscore.ai/trainer" />
        <meta property="og:url" content={`${server}/trainer`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="IELTS Essay Checker (AI) for Writing Task 2. Practice Writing with Top Accuracy and High Quality Platform that Uses Recent 2023 Official Band Descriptors." />
        <meta property="og:description" content="Increase your IELTS Writing Band with Online Writing Task 2 AI Checker. Instant feedback, Tailored Improvement Suggestions. Practice with our cutting-edge evaluation platform to achieve your target, be it Band 9, 8 or 7." />
        <meta property="og:image" content={`${server}/trainer.jpg`} />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content={`${server}`} />
        <meta property="twitter:url" content={`${server}/trainer`} />
        <meta name="twitter:title" content="IELTS Essay Checker (AI) for Writing Task 2. Practice Writing with Top Accuracy and High Quality Platform that Uses Recent 2023 Official Band Descriptors." />
        <meta name="twitter:description" content="Increase your IELTS Writing Band with Online Writing Task 2 AI Checker. Instant feedback, Tailored Improvement Suggestions. Practice with our cutting-edge evaluation platform to achieve your target, be it Band 9, 8 or 7." />
        <meta name="twitter:image" content={`${server}/trainer.jpg`} />
      </Head>

      <Header />

      <main className="flex flex-1 flex-col w-full items-center justify-center md:items-start md:flex-row">
        {
          <aside className="flex flex-col md:sticky md:top-0 md:ml-4 md:mb-0">
            <UserDashboard user={user} isAuthorized={isAuthorized} />
          </aside>
        }
        <Trainer user={user} isAuthorized={isAuthorized} />

      </main>

      {(!isAuthorized || (isAuthorized && !user?.hasProAccess)) ?
        <div>
        <ConversionBlock/>
        <PaymentOptions />
        <Benefits/>
        </div>
        : null
      }
      <Footer />
    </div>
  )
}

export default Home
